import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { userModule } from "@/store/modules/user";
import ErrorPage from "@/components/404.vue";
import LineLogin from "@/components/LineLogin.vue";
import Community from "@/views/Community.vue";
import CommunityRecords from "@/views/CommunityRecords.vue";
import RecordLifeStyle from '@/views/RecordLifeStyle.vue';
import Login from "@/components/Login.vue";
import PatientList from "@/views/PatientList.vue";
import PatientRecords from "@/views/PatientRecords.vue";
import RecordChart from "@/views/RecordChart.vue";
import PatientForm from "@/views/PatientForm.vue";
import SarcopeniaForm from "@/views/SarcopeniaForm.vue";
import VerifyPatients from "@/views/VerifyPatients.vue";
import ApiToken from "@/views/ApiToken.vue";
import RoleList from "@/views/RoleList.vue";
import ParamedicList from "@/views/ParamedicList.vue";
import Dashboard from "@/views/Dashboard.vue";
import ParamedicCharge from "@/views/ParamedicCharge.vue";
import Notification from "@/components/Notification.vue";
import RealtimeMonitor from "@/views/RealtimeMonitor.vue";
import PlaceList from "@/views/PlaceList.vue";
import Scheduler from "@/views/SchedulerJobList.vue";
import AsusDeviceList from "@/views/AsusDevice.vue";
import DeviceCount from "@/views/DeviceCount.vue";
import CommunityHistory from '@/views/CommunityHistory.vue';
import LineMessageConsole from '@/views/LineMessageConsole.vue';
import CountyCommunityMap from '@/views/CountyCommunityMap.vue';
import CountyCommunityMapHistory from '@/views/CountyCommunityMapHistory.vue';
import CommunitySettings from '@/views/CommunitySettings.vue';
import AiCareDemo from "@/views/AiCareDemo.vue";
import CommunityOverview from "@/views/CommunityOverview.vue";


function requireAuth(to: TODO, from: TODO, next: TODO) {
  if (!userModule.isSignedIn) {
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}

function requireRole(to: TODO, from: TODO, next: TODO) {
  console.log(userModule.roles);
  if (!userModule.isSignedIn) {
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  }else if(to.matched.some(record =>{
    let res = false;
    userModule.roles.forEach(role=>{
      if(record.meta.roles.includes(role)) res = true;
    })
    return res;
  })){
    next();
  } else {
    next({
      path: "/map"
    });
  }
}

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes: Array<RouteConfig> = [
  {
    path: "/ai-care-demo",
    component: AiCareDemo,
    name: "AI健康服務協作Demo",
    meta: {
      standalone: true
    }
  },
  {
    path: "/community-overview",
    component: CommunityOverview,
    name: "社區健康服務總覽",
    meta: {
      standalone: true
    }
  },
  { path: "/404", component: ErrorPage, name: "ErrorPage" },
  { path: "/linelink", component: LineLogin, name: "linelink"},
  {
    path: "/patients",
    component: PatientList,
    name: "個案名單",
    beforeEnter: requireAuth
  },
  {
    path: "/dashboard",
    component: Dashboard,
    name: "血壓脈搏圖表",
    beforeEnter: requireAuth
  },
  {
    path: "/paramedic",
    component: ParamedicList,
    name: "照護人員名單",
    beforeEnter: requireAuth
  },
  {
    path: "/paramedic/:id/list",
    component: ParamedicCharge,
    name: "負責個案",
    beforeEnter: requireAuth
  },
  {
    path: "/patients/:id/records",
    component: PatientRecords,
    name: "個案紀錄",
    beforeEnter: requireAuth
  },
  {
    path: "/patients/:id/records/chart",
    component: RecordChart,
    name: "個案紀錄圖表",
    beforeEnter: requireAuth
  },
  {
    path: "/verifyPatients",
    component: VerifyPatients,
    name: '個案審核',
    meta: {
      roles: ['Owner', 'Admin']
    },
    beforeEnter: requireRole
  },
  {
    path: "/newPatient",
    component: PatientForm,
    name: "新增個案",
    beforeEnter: requireAuth
  },
  {
    path: "/SarcopeniaForm/:id",
    component: SarcopeniaForm,
    name: "肌少症判斷",
    beforeEnter: requireAuth
  },
  {
    path: "/apiToken",
    component: ApiToken,
    name: 'API列表',
    beforeEnter: requireAuth
  },
  {
    path: "/roleList",
    component: RoleList,
    name: '權限列表',
    beforeEnter: requireAuth
  },{
    path: "/notification",
    component: Notification,
    name: '通知列表',
    beforeEnter: requireAuth
  },
  {
    path:"/monitor",
    component: RealtimeMonitor,
    name: '血氧體溫圖表',
    beforeEnter: requireAuth
  },
  {
    path:"/placesetup",
    component: PlaceList,
    name: '地區設置',
    meta: {
      roles: ['Owner', 'Admin']
    },
    beforeEnter: requireRole
  },
  {
    path:"/communitysettings",
    component: CommunitySettings,
    name: '社區統計設定',
    meta: {
      roles: ['Owner', 'Admin']
    },
    beforeEnter: requireRole
  },
  {
    path:"/schedulersetup",
    component: Scheduler,
    name: '排程設置',
    meta: {
      roles: ['Owner']
    },
    beforeEnter: requireRole
  },
  //roles: ['Owner', 'Admin']
  {
    path:"/asusdevice",
    component: AsusDeviceList,
    name: 'asus手錶資料',
    meta: {
      roles: ['Owner','Admin']
    },
    beforeEnter: requireRole
  },
  {
    path:"/devices",
    component: DeviceCount,
    name: '機器統計',
    meta: {
      roles: ['Owner','Admin']
    },
    beforeEnter: requireRole
  },
  {
    path:"/map",
    component: CountyCommunityMapHistory,
    name: '社區歷史幻燈片',
    meta: {
      roles: ['Owner','Admin']
    },
    beforeEnter: requireRole
  },
  {
    path:"/new_map",
    component: CountyCommunityMap,
    name: '社區地圖統計',
    meta: {
      roles: ['Owner','Admin']
    },
    beforeEnter: requireRole
  },
  {
    path:"/maphistory",
    component: CommunityHistory,
    name: '地圖歷史資料',
    meta: {
      roles: ['Owner','Admin']
    },
    beforeEnter: requireRole
  },
  {
    path:"/patients/:id/records/lifestyle",
    component: RecordLifeStyle,
    name: '生活型態紀錄',
    beforeEnter: requireAuth
  },
  // {
  //   path: "/community",
  //   component: Community,
  //   name: '社區狀態顯示表',
  //   beforeEnter: requireAuth
  // },
  // {
  //   path: "/community/:name/records",
  //   component: CommunityRecords,
  //   name: "社區紀錄",
  //   beforeEnter: requireAuth
  // },
  {
    path:"/linemsg",
    component: LineMessageConsole,
    name: 'Line-群發訊息',
    meta: {
      roles: ['Owner','Admin']
    },
    beforeEnter: requireRole
  },
  { path: "/login", component: Login, name: "Login" },
  { path: "/", redirect: "/login" },
  { path: "*", redirect: "/404" }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
